import { NgModule, OnInit } from '@angular/core';
import { ActivatedRoute, ActivationStart, Router, RouterModule, Routes } from '@angular/router';

import { HeaderService, HeaderType } from './services/header-service';
import { ApplicationListComponent } from './components/application-list/application-list.component';
import { ApplicationRouteGuard } from './guard/application-route-guard';
import { SendMessageComponent } from './components/send-message/send-message.component';
import { ScheduleAppointmentService } from './modules/schedule-appointment/services/schedule-appointment.service';
import { StaffScheduleDetailsComponent } from './modules/schedule-appointment/components/meeting-details/staff-schedule-details/staff-schedule-details.component';
import { DatePipe } from '@angular/common';

const routes: Routes = [
	{
		path: 'debitcardppplication',
		loadChildren: () => import('./modules/debit-card-application/debit-card-application.module').then((m) => m.DebitCardApplicationModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Debit Card Application',
		},
	},
	// This is a generic route which redirect user to appropriate component
	{
		path: 'debitcardppplication/:id',
		canActivate: [ApplicationRouteGuard],
		loadChildren: () => import('./modules/debit-card-application/debit-card-application.module').then((m) => m.DebitCardApplicationModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Debit Card Application',
		},
	},
	{
		path: 'accountopening',
		loadChildren: () => import('./modules/account-opening/account-opening.module').then((m) => m.AccountOpeningModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Account Opening',
		},
	},
	{
		path: 'accountopening/:id',
		loadChildren: () => import('./modules/account-opening/account-opening.module').then((m) => m.AccountOpeningModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Account Opening',
		},
	},

	{
		path: 'insuranceApplication',
		loadChildren: () => import('./modules/insurance-application/insurance-application.module').then((m) => m.InsuranceApplicationModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Insurance Application',
		},
	},
	{
		path: 'insuranceApplication/:id',
		loadChildren: () => import('./modules/insurance-application/insurance-application.module').then((m) => m.InsuranceApplicationModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Insurance Application',
		},
	},
	{
		path: 'commercialLoanApplication',
		loadChildren: () => import('./modules/commercial-loan/commercial-loan.module').then((m) => m.CommercialLoanApplicationModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Commercial Loan Application',
		},
	},
	{
		path: 'commercialLoanApplication/:id',
		loadChildren: () => import('./modules/commercial-loan/commercial-loan.module').then((m) => m.CommercialLoanApplicationModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Commercial Loan Application',
		},
	},

	//{ path: 'clientapplicationstatus', component: ClientApplicationStatusComponent, data: { headerType: HeaderType.clientApplicationHeader}, canActivate: [UserValidationGuard] },
	{ path: 'applicationlist', component: ApplicationListComponent, data: { headerType: HeaderType.logoOnly } },

	{
		path: 'applicationlist/:id',
		loadChildren: () => import('./modules/account-opening/account-opening.module').then((m) => m.AccountOpeningModule),
		data: {
			headerType: HeaderType.logoOnly,
			headerText: 'Account Opening',
		},
	},

	{ path: 'sendmessage', component: SendMessageComponent, data: { headerType: HeaderType.logoOnly } },
	{
		path: 'schedule',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/schedule-appointment.component.module').then((m) => m.ScheduleAppointmentModule),
	},
	{
		path: 'schedule/:userGUID',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/schedule-appointment.component.module').then((m) => m.ScheduleAppointmentModule),
	},
	{
		path: 'schedule/service/:serviceGUID',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/schedule-appointment.component.module').then((m) => m.ScheduleAppointmentModule),
	},
	{
		path: 'appointment',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/manage-appointment.component.module').then((m) => m.ManageAppointmentModule),
	},
	{
		path: 'appointment/:customerAppointmentGUID',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/manage-appointment.component.module').then((m) => m.ManageAppointmentModule),
	},
	{ path: '**', redirectTo: 'https://www.trb.bank', data: { headerType: HeaderType.logoOnly } },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			onSameUrlNavigation: 'reload',
		}),
	],
	exports: [RouterModule],
	providers: [
		ScheduleAppointmentService,
		//VerficationService, AuthGuard, UserValidationGuard
	],
})
export class AppRoutingModule implements OnInit {
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public headerService: HeaderService
	) {
		// this.router.routeReuseStrategy.shouldReuseRoute = () => {
		//   return false;
		// };
		this.router.events.subscribe((event) => {
			if (event instanceof ActivationStart) {
				const data = event.snapshot.data;
				if (data?.headerType) {
					this.headerService.headerType = data.headerType;
				}
				this.headerService.headerText = data?.headerText;
			}
		});
		// this.activatedRoute.data.subscribe(data => {
		//   console.log(data);
		//       if(data?.headerType){
		//         this.headerService.headerType = data.headerType;
		//       }
		//       this.headerService.headerText = data?.headerText;
		//   })
	}

	ngOnInit() {}
}
